import {
  getAngleBy2XY,
  getDistanceBy2XY,
  CoordsType,
} from '../../utils/geometry';
import Order from './order';
import Ship from '../element/ship/ship';

interface FollowOrderParams {
  target: Ship;
  distanceToReach: number;
  onDistanceReached?: (modifier: number, self: FollowOrder) => void;
}

const defaultOnReachedFn = (modifier: number, self: FollowOrder) => self.getElement().brake(modifier);

export default class FollowOrder extends Order {
  target: Ship;
  distanceToReach: number;
  onDistanceReached: (modifier: number, self: FollowOrder) => void;

  constructor(params: FollowOrderParams) {
    super();
    this.target = params.target;
    this.distanceToReach = params.distanceToReach;
    this.onDistanceReached = params.onDistanceReached ?? defaultOnReachedFn;
    this.color = 'green';
  }

  getEndCoords(): CoordsType {
    const { x, y} = this.target;
    return {
      x,
      y,
    };
  }

  update(modifier: number): FollowOrder {
    const element = this.getElement();
    const {
      target,
    } = this;

    const {
      x,
      y,
    } = element;

    const destinationAngle = getAngleBy2XY({
      x1: x,
      y1: y,
      x2: target.x,
      y2: target.y,
    });
    element.moveAngle = element.rotateTowardsAngle(destinationAngle, modifier);

    const distanceToObjective = getDistanceBy2XY({
      x1: this.behaviour.element.x,
      y1: this.behaviour.element.y,
      x2: target.x,
      y2: target.y,
    });
    const distanceReached = distanceToObjective <= this.distanceToReach;
    if (distanceReached)
      this.onDistanceReached(modifier, this);
    else
      element.accelerate(modifier); // move towards target

    return this;
  }

  onStart(): void {
    this.distanceToReach = this.distanceToReach ?? Math.max(
      this.getElement().width,
      this.getElement().height
    ) + Math.max(
      this.target.width,
      this.target.height
    );
  }

  onComplete(): void {
    this.getElement().stop();
  }

  isComplete(): boolean {
    return (
      this.getElement() === undefined // your element doesn't exists
      || this.getElements()[this.target.id] === undefined // your target doesn't exists
      || this.getElement().id === this.target.id // don't follow yourself
    );
  }

  isPossible(): boolean {
    return (this.getElement()?.moveSpeedMax > 0); // can't move: "Game over man, game over!"
  }
}
